import { ActionPointInfo, Controller, IActionPointInfo, Menu, Titlebar, Toolbar } from '@tencent/workbench';
import { MENU_CONFIGS, TOOLBAR_CONFIGS, config } from '@framework/workbench/ui/print/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { PrintFeature } from '@framework/workbench/ui/print/print-feature';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { TitlebarKey } from '@tencent/docs-titlebar-service';
import { MenuKey } from '../../schema/menu-schema/common';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { TitleBarConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { ENV } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { isCloudSlide } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';

@Controller({
    menuItems: MENU_CONFIGS,
    toolbarItems: TOOLBAR_CONFIGS,
})
export class PrintController {
    constructor(private readonly feature: PrintFeature) {
    }

    @Toolbar(ActionType.PRINT, 'onClick')
    @Toolbar(wrapIdForBig(ActionType.PRINT), 'onClick')
    @Menu(ActionType.PRINT, 'onClick')
    @Titlebar(TitlebarKey.PRINT, 'onClick')
    @Menu(MenuKey.PRINT_HOR, 'onClick')
    @Menu(MenuKey.PRINT, 'onClick')
    public handlePrint(@ActionPointInfo() info: IActionPointInfo) {
        this.feature.handlePrint();
        this.reportPrint(info.from === 'toolbar');
    }

    @Menu(ActionType.PRINT, 'description')
    public getDescription() {
        let description = '';
        if (browser.isMac) {
            description = '⌘ + P';
        } else if (browser.isWindows) {
            description = 'Ctrl + P';
        }
        return description;
    }

    @Toolbar(ActionType.PRINT, 'tooltip')
    @Toolbar(wrapIdForBig(ActionType.PRINT), 'tooltip')
    public authHoverTips() {
        return config.tipMsg;
    }

    @Toolbar(ActionType.PRINT, 'shouldHide')
    @Toolbar(wrapIdForBig(ActionType.PRINT), 'shouldHide')
    @Menu(ActionType.PRINT, 'shouldHide')
    public shouldHidePrint() {
        return this.feature.shouldHidePrint();
    }

    // 右上角菜单 顶部横向菜单
    @Menu(MenuKey.PRINT_HOR, 'shouldHide')
    public shouldHidePrintMenuHor() {
        // 本地编辑和云文档不显示横向菜单的【打印】
        return this.shouldHidePrint() || ENV.IS_PC_LOCAL_EDIT || isCloudSlide();
    }

    // 右上角菜单
    @Menu(MenuKey.PRINT, 'shouldHide')
    public shouldHidePrintMenu() {
        // 本地编辑才显示
        return this.shouldHidePrint() || !ENV.IS_PC_LOCAL_EDIT;
    }

    @Titlebar(TitlebarKey.PRINT, 'shouldHide')
    public shouldHideTitleBarPrint() {
        return this.shouldHidePrint() || !(appConfigInstance.getConfig(TitleBarConfig.print as any) ?? true);
    }

    @Toolbar(ActionType.PRINT, 'shouldDisabled')
    @Toolbar(wrapIdForBig(ActionType.PRINT), 'shouldDisabled')
    @Menu(ActionType.PRINT, 'shouldDisabled')
    @Titlebar(TitlebarKey.PRINT, 'shouldDisabled')
    @Menu(MenuKey.PRINT_HOR, 'shouldDisabled')
    @Menu(MenuKey.PRINT, 'shouldDisabled')
    public shouldDisablePrint() {
        return this.feature.shouldDisablePrint();
    }

    private reportPrint = (fromToolbar) => {
        tdw({
            opername: TDWOperationType.PRINT_PPT,
            module: fromToolbar ? TDWModuleType.PC_TITLEBAR : TDWModuleType.PC_MORE,
            action: TDWActionType.PRINT_ENTRANCE_CLICK,
        });
    };
}
